// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================
   PREMIUM HERO SECTION
============================ */

.hero-section {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    padding: 120px 20px 80px;
}

/* ============================
   ANIMATED BACKGROUND
============================ */

.hero-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    overflow: hidden;
}

.gradient-orb {
    position: absolute;
    border-radius: 50%;
    filter: blur(100px);
    opacity: 0.4;
    animation: float 20s ease-in-out infinite;
    transition: transform 0.3s ease-out;
}

.orb-1 {
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(99, 102, 241, 0.6), transparent 70%);
    top: -15%;
    left: -10%;
    animation-delay: 0s;
}

.orb-2 {
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(168, 85, 247, 0.5), transparent 70%);
    top: 40%;
    right: -10%;
    animation-delay: 2s;
}

.orb-3 {
    width: 550px;
    height: 550px;
    background: radial-gradient(circle, rgba(59, 130, 246, 0.5), transparent 70%);
    bottom: -15%;
    left: 30%;
    animation-delay: 4s;
}

@keyframes float {
    0%, 100% {
        transform: translate(0, 0) scale(1);
    }
    33% {
        transform: translate(40px, -40px) scale(1.15);
    }
    66% {
        transform: translate(-40px, 40px) scale(0.95);
    }
}

/* ============================
   CONTENT CONTAINER
============================ */

.hero-content {
    position: relative;
    z-index: 10;
    text-align: center;
    max-width: 1100px;
    margin: 0 auto;
    opacity: 0;
    transform: translateY(40px);
    transition: all 1.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.hero-content.is-visible {
    opacity: 1;
    transform: translateY(0);
}

/* ============================
   BADGE
============================ */

.hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 24px;
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(139, 92, 246, 0.4);
    border-radius: 50px;
    font-size: 0.875rem;
    color: rgba(255, 255, 255, 0.95);
    margin-bottom: 40px;
    backdrop-filter: blur(10px);
    animation: fadeInScale 1s ease-out 0.3s both;
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);
}

.badge-dot {
    width: 8px;
    height: 8px;
    background: linear-gradient(135deg, #6366f1, #a855f7);
    border-radius: 50%;
    animation: pulse 2s ease-in-out infinite;
    box-shadow: 0 0 10px rgba(168, 85, 247, 0.6);
}

@keyframes pulse {
    0%, 100% {
        opacity: 1;
        transform: scale(1);
    }
    50% {
        opacity: 0.7;
        transform: scale(1.3);
    }
}

@keyframes fadeInScale {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* ============================
   TYPOGRAPHY
============================ */

.hero-title {
    font-size: clamp(2.5rem, 5vw, 4.5rem);
    font-weight: 800;
    color: #ffffff;
    margin-bottom: 20px;
    letter-spacing: -0.03em;
    line-height: 1.1;
    animation: fadeInUp 1s ease-out 0.4s both;
    text-shadow: 0 4px 20px rgba(99, 102, 241, 0.3);
}

.hero-subtitle-main {
    font-size: clamp(1.75rem, 3.5vw, 3.2rem);
    font-weight: 600;
    color: rgba(255, 255, 255, 0.98);
    margin-bottom: 28px;
    letter-spacing: -0.02em;
    line-height: 1.3;
    animation: fadeInUp 1s ease-out 0.5s both;
}

.gradient-text {
    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);
    background-size: 200% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: shimmer 4s ease-in-out infinite;
}

@keyframes shimmer {
    0%, 100% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
}

.hero-description {
    font-size: clamp(1rem, 1.5vw, 1.25rem);
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.7;
    margin-bottom: 50px;
    font-weight: 400;
    animation: fadeInUp 1s ease-out 0.6s both;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ============================
   BUTTONS
============================ */

.hero-buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 70px;
    animation: fadeInUp 1s ease-out 0.7s both;
}

.btn-primary,
.btn-secondary {
    padding: 18px 36px;
    border-radius: 14px;
    font-size: 1.0625rem;
    font-weight: 600;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    position: relative;
    overflow: hidden;
}

.btn-primary {
    background: linear-gradient(135deg, #6366f1, #a855f7);
    color: #ffffff;
    border: none;
    box-shadow: 0 10px 40px rgba(99, 102, 241, 0.4);
}

.btn-primary::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.6s ease;
}

.btn-primary:hover::before {
    left: 100%;
}

.btn-primary:hover {
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 15px 50px rgba(99, 102, 241, 0.5);
}

.btn-secondary {
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
}

.btn-secondary:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-3px) scale(1.02);
}

/* ============================
/* ============================
   STATS (Updated with White Color)
============================ */

.hero-stats {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 50px;
    flex-wrap: wrap;
    animation: fadeInUp 1s ease-out 0.8s both;
    z-index: 10; /* Ensure stats are above other elements */
}

.stat-item {
    text-align: center;
    opacity: 1; /* Ensure the stats are visible */
    z-index: 5; /* Prevent other elements from overlapping */
}

.stat-number {
    font-size: 2.25rem;
    font-weight: 800;
    color: #ffffff; /* Set text color to plain white */
    margin-bottom: 6px;
    text-shadow: 0 4px 15px rgba(255, 255, 255, 0.6); /* Lighter shadow for better visibility */
    opacity: 1; /* Ensure the numbers are visible */
}

.stat-label {
    font-size: 0.9375rem;
    color: rgba(255, 255, 255, 0.85); /* Slightly off-white for the label */
    font-weight: 500;
}

.stat-divider {
    width: 1px;
    height: 50px;
    background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.3), transparent);
    display: block; /* Ensure the divider is visible */
}

/* ============================
   RESPONSIVE (For Small Screens)
============================ */

@media (max-width: 768px) {
    .hero-stats {
        gap: 30px;
    }

    .stat-item {
        font-size: 1rem; /* Adjust size for smaller screens */
    }

    .stat-divider {
        display: none;
    }
}

/* ============================
   FLOATING ELEMENTS
============================ */

.floating-elements {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 5;
}

.float-element {
    position: absolute;
    font-size: 2.5rem;
    opacity: 0.2;
    animation: floatAround 18s ease-in-out infinite;
    filter: drop-shadow(0 0 10px rgba(168, 85, 247, 0.4));
}

.element-1 {
    top: 15%;
    left: 10%;
    animation-delay: 0s;
}

.element-2 {
    top: 70%;
    left: 15%;
    animation-delay: 3s;
}

.element-3 {
    top: 20%;
    right: 10%;
    animation-delay: 6s;
}

.element-4 {
    bottom: 20%;
    right: 15%;
    animation-delay: 9s;
}

@keyframes floatAround {
    0%, 100% {
        transform: translate(0, 0) rotate(0deg);
    }
    25% {
        transform: translate(25px, -25px) rotate(90deg);
    }
    50% {
        transform: translate(0, -50px) rotate(180deg);
    }
    75% {
        transform: translate(-25px, -25px) rotate(270deg);
    }
}

/* ============================
   RESPONSIVE
============================ */

@media (max-width: 768px) {
    .hero-section {
        padding: 100px 20px 60px;
    }

    .hero-stats {
        gap: 30px;
    }

    .stat-divider {
        display: none;
    }

    .btn-primary,
    .btn-secondary {
        width: 100%;
        justify-content: center;
    }

    .hero-badge {
        font-size: 0.8125rem;
        padding: 8px 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero.css"],"names":[],"mappings":"AAAA;;8BAE8B;;AAE9B;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;;8BAE8B;;AAE9B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,yCAAyC;IACzC,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6EAA6E;IAC7E,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6EAA6E;IAC7E,QAAQ;IACR,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6EAA6E;IAC7E,YAAY;IACZ,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,mCAAmC;IACvC;IACA;QACI,6CAA6C;IACjD;IACA;QACI,6CAA6C;IACjD;AACJ;;AAEA;;8BAE8B;;AAE9B;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,2BAA2B;IAC3B,kDAAkD;AACtD;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;;8BAE8B;;AAE9B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,2BAA2B;IAC3B,4CAA4C;IAC5C,8CAA8C;AAClD;;AAEA;IACI,UAAU;IACV,WAAW;IACX,qDAAqD;IACrD,kBAAkB;IAClB,wCAAwC;IACxC,4CAA4C;AAChD;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;;8BAE8B;;AAE9B;IACI,qCAAqC;IACrC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,yCAAyC;IACzC,+CAA+C;AACnD;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,8DAA8D;IAC9D,0BAA0B;IAC1B,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI,sCAAsC;IACtC,gCAAgC;IAChC,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;8BAE8B;;AAE9B;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uCAAuC;IACvC,+CAA+C;AACnD;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;;;8BAG8B;;AAE9B;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,yCAAyC;IACzC,WAAW,EAAE,0CAA0C;AAC3D;;AAEA;IACI,kBAAkB;IAClB,UAAU,EAAE,iCAAiC;IAC7C,UAAU,EAAE,4CAA4C;AAC5D;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc,EAAE,kCAAkC;IAClD,kBAAkB;IAClB,gDAAgD,EAAE,yCAAyC;IAC3F,UAAU,EAAE,mCAAmC;AACnD;;AAEA;IACI,oBAAoB;IACpB,gCAAgC,EAAE,qCAAqC;IACvE,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,0FAA0F;IAC1F,cAAc,EAAE,kCAAkC;AACtD;;AAEA;;8BAE8B;;AAE9B;IACI;QACI,SAAS;IACb;;IAEA;QACI,eAAe,EAAE,oCAAoC;IACzD;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;;8BAE8B;;AAE9B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,+CAA+C;IAC/C,qDAAqD;AACzD;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI;QACI,uCAAuC;IAC3C;IACA;QACI,+CAA+C;IACnD;IACA;QACI,6CAA6C;IACjD;IACA;QACI,iDAAiD;IACrD;AACJ;;AAEA;;8BAE8B;;AAE9B;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;IACrB;AACJ","sourcesContent":["/* ============================\n   PREMIUM HERO SECTION\n============================ */\n\n.hero-section {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    overflow: hidden;\n    padding: 120px 20px 80px;\n}\n\n/* ============================\n   ANIMATED BACKGROUND\n============================ */\n\n.hero-background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 0;\n    overflow: hidden;\n}\n\n.gradient-orb {\n    position: absolute;\n    border-radius: 50%;\n    filter: blur(100px);\n    opacity: 0.4;\n    animation: float 20s ease-in-out infinite;\n    transition: transform 0.3s ease-out;\n}\n\n.orb-1 {\n    width: 600px;\n    height: 600px;\n    background: radial-gradient(circle, rgba(99, 102, 241, 0.6), transparent 70%);\n    top: -15%;\n    left: -10%;\n    animation-delay: 0s;\n}\n\n.orb-2 {\n    width: 500px;\n    height: 500px;\n    background: radial-gradient(circle, rgba(168, 85, 247, 0.5), transparent 70%);\n    top: 40%;\n    right: -10%;\n    animation-delay: 2s;\n}\n\n.orb-3 {\n    width: 550px;\n    height: 550px;\n    background: radial-gradient(circle, rgba(59, 130, 246, 0.5), transparent 70%);\n    bottom: -15%;\n    left: 30%;\n    animation-delay: 4s;\n}\n\n@keyframes float {\n    0%, 100% {\n        transform: translate(0, 0) scale(1);\n    }\n    33% {\n        transform: translate(40px, -40px) scale(1.15);\n    }\n    66% {\n        transform: translate(-40px, 40px) scale(0.95);\n    }\n}\n\n/* ============================\n   CONTENT CONTAINER\n============================ */\n\n.hero-content {\n    position: relative;\n    z-index: 10;\n    text-align: center;\n    max-width: 1100px;\n    margin: 0 auto;\n    opacity: 0;\n    transform: translateY(40px);\n    transition: all 1.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.hero-content.is-visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n/* ============================\n   BADGE\n============================ */\n\n.hero-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 24px;\n    background: rgba(99, 102, 241, 0.15);\n    border: 1px solid rgba(139, 92, 246, 0.4);\n    border-radius: 50px;\n    font-size: 0.875rem;\n    color: rgba(255, 255, 255, 0.95);\n    margin-bottom: 40px;\n    backdrop-filter: blur(10px);\n    animation: fadeInScale 1s ease-out 0.3s both;\n    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);\n}\n\n.badge-dot {\n    width: 8px;\n    height: 8px;\n    background: linear-gradient(135deg, #6366f1, #a855f7);\n    border-radius: 50%;\n    animation: pulse 2s ease-in-out infinite;\n    box-shadow: 0 0 10px rgba(168, 85, 247, 0.6);\n}\n\n@keyframes pulse {\n    0%, 100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n    50% {\n        opacity: 0.7;\n        transform: scale(1.3);\n    }\n}\n\n@keyframes fadeInScale {\n    from {\n        opacity: 0;\n        transform: scale(0.9);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n/* ============================\n   TYPOGRAPHY\n============================ */\n\n.hero-title {\n    font-size: clamp(2.5rem, 5vw, 4.5rem);\n    font-weight: 800;\n    color: #ffffff;\n    margin-bottom: 20px;\n    letter-spacing: -0.03em;\n    line-height: 1.1;\n    animation: fadeInUp 1s ease-out 0.4s both;\n    text-shadow: 0 4px 20px rgba(99, 102, 241, 0.3);\n}\n\n.hero-subtitle-main {\n    font-size: clamp(1.75rem, 3.5vw, 3.2rem);\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.98);\n    margin-bottom: 28px;\n    letter-spacing: -0.02em;\n    line-height: 1.3;\n    animation: fadeInUp 1s ease-out 0.5s both;\n}\n\n.gradient-text {\n    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);\n    background-size: 200% auto;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    animation: shimmer 4s ease-in-out infinite;\n}\n\n@keyframes shimmer {\n    0%, 100% {\n        background-position: 0% 50%;\n    }\n    50% {\n        background-position: 100% 50%;\n    }\n}\n\n.hero-description {\n    font-size: clamp(1rem, 1.5vw, 1.25rem);\n    color: rgba(255, 255, 255, 0.85);\n    line-height: 1.7;\n    margin-bottom: 50px;\n    font-weight: 400;\n    animation: fadeInUp 1s ease-out 0.6s both;\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* ============================\n   BUTTONS\n============================ */\n\n.hero-buttons {\n    display: flex;\n    gap: 20px;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin-bottom: 70px;\n    animation: fadeInUp 1s ease-out 0.7s both;\n}\n\n.btn-primary,\n.btn-secondary {\n    padding: 18px 36px;\n    border-radius: 14px;\n    font-size: 1.0625rem;\n    font-weight: 600;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n    position: relative;\n    overflow: hidden;\n}\n\n.btn-primary {\n    background: linear-gradient(135deg, #6366f1, #a855f7);\n    color: #ffffff;\n    border: none;\n    box-shadow: 0 10px 40px rgba(99, 102, 241, 0.4);\n}\n\n.btn-primary::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\n    transition: left 0.6s ease;\n}\n\n.btn-primary:hover::before {\n    left: 100%;\n}\n\n.btn-primary:hover {\n    transform: translateY(-3px) scale(1.02);\n    box-shadow: 0 15px 50px rgba(99, 102, 241, 0.5);\n}\n\n.btn-secondary {\n    background: rgba(255, 255, 255, 0.08);\n    color: rgba(255, 255, 255, 0.95);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(10px);\n}\n\n.btn-secondary:hover {\n    background: rgba(255, 255, 255, 0.15);\n    border-color: rgba(255, 255, 255, 0.3);\n    transform: translateY(-3px) scale(1.02);\n}\n\n/* ============================\n/* ============================\n   STATS (Updated with White Color)\n============================ */\n\n.hero-stats {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 50px;\n    flex-wrap: wrap;\n    animation: fadeInUp 1s ease-out 0.8s both;\n    z-index: 10; /* Ensure stats are above other elements */\n}\n\n.stat-item {\n    text-align: center;\n    opacity: 1; /* Ensure the stats are visible */\n    z-index: 5; /* Prevent other elements from overlapping */\n}\n\n.stat-number {\n    font-size: 2.25rem;\n    font-weight: 800;\n    color: #ffffff; /* Set text color to plain white */\n    margin-bottom: 6px;\n    text-shadow: 0 4px 15px rgba(255, 255, 255, 0.6); /* Lighter shadow for better visibility */\n    opacity: 1; /* Ensure the numbers are visible */\n}\n\n.stat-label {\n    font-size: 0.9375rem;\n    color: rgba(255, 255, 255, 0.85); /* Slightly off-white for the label */\n    font-weight: 500;\n}\n\n.stat-divider {\n    width: 1px;\n    height: 50px;\n    background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.3), transparent);\n    display: block; /* Ensure the divider is visible */\n}\n\n/* ============================\n   RESPONSIVE (For Small Screens)\n============================ */\n\n@media (max-width: 768px) {\n    .hero-stats {\n        gap: 30px;\n    }\n\n    .stat-item {\n        font-size: 1rem; /* Adjust size for smaller screens */\n    }\n\n    .stat-divider {\n        display: none;\n    }\n}\n\n/* ============================\n   FLOATING ELEMENTS\n============================ */\n\n.floating-elements {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    z-index: 5;\n}\n\n.float-element {\n    position: absolute;\n    font-size: 2.5rem;\n    opacity: 0.2;\n    animation: floatAround 18s ease-in-out infinite;\n    filter: drop-shadow(0 0 10px rgba(168, 85, 247, 0.4));\n}\n\n.element-1 {\n    top: 15%;\n    left: 10%;\n    animation-delay: 0s;\n}\n\n.element-2 {\n    top: 70%;\n    left: 15%;\n    animation-delay: 3s;\n}\n\n.element-3 {\n    top: 20%;\n    right: 10%;\n    animation-delay: 6s;\n}\n\n.element-4 {\n    bottom: 20%;\n    right: 15%;\n    animation-delay: 9s;\n}\n\n@keyframes floatAround {\n    0%, 100% {\n        transform: translate(0, 0) rotate(0deg);\n    }\n    25% {\n        transform: translate(25px, -25px) rotate(90deg);\n    }\n    50% {\n        transform: translate(0, -50px) rotate(180deg);\n    }\n    75% {\n        transform: translate(-25px, -25px) rotate(270deg);\n    }\n}\n\n/* ============================\n   RESPONSIVE\n============================ */\n\n@media (max-width: 768px) {\n    .hero-section {\n        padding: 100px 20px 60px;\n    }\n\n    .hero-stats {\n        gap: 30px;\n    }\n\n    .stat-divider {\n        display: none;\n    }\n\n    .btn-primary,\n    .btn-secondary {\n        width: 100%;\n        justify-content: center;\n    }\n\n    .hero-badge {\n        font-size: 0.8125rem;\n        padding: 8px 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
